import React from 'react'
import { Card } from "@inspinia-react"
import { api, get } from "@config"
import ReawrdHistory from './rewardHistory'

export default class Afilliation extends React.Component {

    constructor(props) {
        super(props);

        this.state = { data: {actives_invites: [] }, title: "", totalReaward: 0 }
        this.showUsers = this.showUsers.bind(this)
    }

    showUsers() { }
    showAffiliateRewardHistory() { }

    UNSAFE_componentWillMount() {
        const url = `${api.users.myIndications}`
        const payload = data => {
            this.setState({ ...this, data })
        }
        get(url, payload)
    }

    render() {
        return <div>
            <h1 className='py-3'>Informações de Afiliação</h1>

            <div className="d-flex flex-lg-row flex-column" >
                <Card
                    label='Clicaram no link'
                    total={23}
                    isNotCurrency
                    shadow
                    footerLabel="Visualizar"
                />
                <Card
                    label="Indicados cadastrados"
                    total={ this.state.data.actives_invites.length }
                    isNotCurrency
                    shadow
                    footerLabel="Visualizar" i
                    onFooter={this.showUsers}
                />
                <Card
                    label="Total ganho"
                    total={ this.state.totalReaward}
                    shadow
                    footerLabel="Histórico"
                    onFooter={() => {  } }
                />
            </div>
            <div className="row py-2">
                <div className="col-10">
                    <h1>
                        {
                            this.state.title
                        }
                    </h1>
                    <ReawrdHistory rewards={this.state.data.available_rewards || []} />
                </div>
            </div>

        </div>
    }
}


// WEBPACK FOOTER //
// ./src/components/pages/afilliation/index.jsx